import React from 'react';
import {layoutSelectors} from 'features/layout/redux';
import {useSelector} from 'react-redux';
import {IDiplomatObject} from 'types/DiplomatObject';

export const useFilteredTransactionsOrPartners = (filter?: string, byPartners: boolean = false) => {
   const transactions = useSelector(layoutSelectors.transactionsSelector) as IDiplomatObject[];
   const synchronizations = useSelector(
      layoutSelectors.synchronizationsSelector
   ) as IDiplomatObject[];

   const partners = useSelector(layoutSelectors.partnersSelector);

   const filtered = React.useMemo(() => {
      let items;
      if (byPartners) {
         items = partners.publicPartners.concat(partners.trustedPartners);
      } else {
         items = transactions.concat(synchronizations);
      }
      const _filter = filter?.toLowerCase();

      return _filter ? items.filter((t) => t.name.toLowerCase().indexOf(_filter) >= 0) : items;
   }, [transactions, synchronizations, filter, partners, byPartners]);

   return filtered;
};
